export const sgzMarkerRealTimeSelector = ({sgzMarkerRealTime}) => sgzMarkerRealTime
